import "fetch-detector";
import 'fetch-ie8';

import AppUtil from './../utils/app-util';
import Util from './../utils/Utils';
import {BusinessUtil} from "../utils/BusinessUtil";
import StorageUtil from "../utils/storage-util";
import UrlUtil from "../utils/url-config";
import zh_CN from "../locale/zh_CN"; // 中文
import es_ES from "../locale/es_ES"
import en_US from "../locale/en_US" // 英语
import {SystemConst} from "../utils/constant";
import {CommonUtil} from "../utils/common-utils";
import md5 from "md5";

const reqKey = "yunshang";
const API = UrlUtil.getAPI();

// 多语言
const messages = {
    'zh': zh_CN,
    'es': es_ES,
    'en': en_US
};
const lang = StorageUtil.getItem(SystemConst.lang) || 'zh';


// 铺货上报接口
export const DistributionReportFetch = {
    searchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/saleOrder/searchProductList`, _params, _success, _error);
    },
    distributionReportSave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sl/clientGoodsReport/save`, {_meth: 'body', ..._params}, _success, _error)
    },
};

// 金饰定制模块接口
export const GoldOrnamentFetch = {
    //获取金饰定制设置
    getByCompany: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goldOrnamentSetting/noAuth/getByCompany/${_params}`, _params, _success, _error)
    },
    // 查询销量最大前3条商品信息
    searchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goldOrnamentProduct/noAuth/searchList`, _params, _success, _error);
    },
    searchOrnamentGoodsList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goldOrnamentGoods/noAuth/searchList`, _params, _success, _error);
    },
    goldOrnamentProduct: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goldOrnamentProduct/noAuth/getById/${_params.id_}/${_params.company_id_}`, _params, _success, _error)
    },
    searchElectroplateTechnologyList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goldOrnamentSetting/noAuth/searchElectroplateTechnologyList`, _params, _success, _error);
    },
    searchStoneColourList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goldOrnamentSetting/noAuth/searchStoneColourList`, _params, _success, _error);
    },
    searchStoneCutTechnologyList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goldOrnamentSetting/noAuth/searchStoneCutTechnologyList`, _params, _success, _error);
    },
};
//商品模块接口
export const ShopFetch = {
    //生鲜码上溯源
    getTraceabilityInfo: (_params, _success, _error) => {
        _request('GET', `${API}/v1/house/outHouse/noAuth/getTraceabilityInfoByItemId/${_params} `, _params, _success, _error)
    },
    //码上溯源
    codeTraceability: (_params1, _params2, _success, _error) => {
        _request('GET', `${API}/v1/goodsMgr/noAuth/codeTraceability/${_params1}/${_params2} `, _params1, _success, _error)
    },
    updateStatus: (_params, _success, _error) => {
        _request('POST', `${API}/v1/base/user/updateStatus`, _params, _success, _error)
    },
    saveChildUser: (_params, _success, _error) => {
        _request('POST', `${API}/v1/client/client/saveChildUser`, {_meth: 'body', ..._params}, _success, _error)
    },
    searchChildUser: (_params, _success, _error) => {
        _request('GET', `${API}/v1/client/client/searchChildUser`, _params, _success, _error)
    },
    //获取客户设置信息
    getClientSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sl/clientSetting/getByCompanyId`, _params, _success, _error)
    },
    //获取商品首页广告图
    searchBannerList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/home/noAuth/searchBannerList`, _params, _success, _error);
    },
    //记录当前广告的点击次数
    updateBannerClick: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/home/noAuth/changeClickNum/${_params}`, _params, _success, _error)
    },
    //获取商品首页广告图
    searchIndexGoodsList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/home/noAuth/searchIndexGoodsList`, _params, _success, _error)
    },
    //分页获取首页公告列表
    searchNoticeList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/home/noAuth/searchNoticeList`, _params, _success, _error)
    },
    //获取公告详情
    getNoticeById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/home/noAuth/getNoticeById/${_params}`, _params, _success, _error)
    },
    //获取商品详情
    getGoodsById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/getGoodsById/` + _params, _params, _success, _error)
    },
    //获取商品详情
    getGoodsByIdAndClientIdForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/getGoodsByIdAndClientIdForShop`, _params, _success, _error)
    },
    // 根据产品条形码获取客户产品信息
    getGoodsByBarcodeAndClientIdForShop: (_params, _success) => {
        _request('GET', `${API}/v1/shop/goods/getGoodsByBarcodeAndClientIdForShop`, _params, _success)
    },
    //商城商品分页查询
    searchListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/searchListForShop`, _params, _success, _error)
    },
    //web端查询收藏商品
    searchFavoriteGoodsForWeb: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/searchFavoriteGoodsForWeb`, _params, _success, _error)
    },
    //web端收藏商品分类筛选
    searchTypeByFavorite: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/searchTypeByFavorite`, _params, _success, _error)
    },
    //web端查询常购商品清单
    searchClientGoodsForWeb: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/searchClientGoodsForWeb`, _params, _success, _error)
    },
    //web端常购商品分类筛选
    searchTypeByClientGoods: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/searchTypeByClientGoods`, _params, _success, _error)
    },
    //获取指定公司的商品分类树
    getUsePropertyTree: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/getUsePropertyTree`, _params, _success, _error)
    },
    //商城商品分页查询
    searchGoods: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/searchGoods`, _params, _success, _error)
    },
    //我收藏的商品分页查询
    searchFavoriteListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goodsFavorite/noAuth/searchFavoriteListForShop`, _params, _success, _error)
    },
    //查询商品被收藏数量
    countFavorites: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goodsFavorite/noAuth/countFavorites/${_params}`, _params, _success, _error)
    },
    //商城商品分页查询
    checkPhone: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/account/checkPhone`, _params, _success, _error)
    },
    addGoodsFavorite: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/goodsFavorite/addGoodsFavorite`, _params, _success, _error)
    },
    deleteGoodsFavorite: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/goodsFavorite/deleteGoodsFavorite`, _params, _success, _error)
    },
    batchDeleteGoodsFavorite: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/goodsFavorite/batchDeleteGoodsFavorite`, _params, _success, _error)
    },
    //列出企业所有商品风格
    listStyleByCompany: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/listStyleByCompany`, _params, _success, _error)
    },
    //列出企业所有商品品牌
    listBrandByCompany: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/listBrandByCompany`, _params, _success, _error)
    },
    //列出企业所有商品分类
    listTypeByCompany: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/getTypeTree`, _params, _success, _error)
    },
    //列出企业所有商品标签
    searchTagList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/listTagByCompany`, _params, _success, _error)
    },
    //获取商品设置信息
    getGoodsSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/goodsSetting/getByCompanyId/${_params}`, _params, _success, _error)
    },
    //获取销售设置信息
    getSaleSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/setting/getSaleSetting/${_params}`, _params, _success, _error)
    },
    //获取销售设置信息
    getShopSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/setting/getShopSetting/${_params}`, _params, _success, _error)
    },
    //获取商城开放注册应用设置
    getShopRegisterSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shopRegisterSetting/noAuth/getByCompany`, _params, _success, _error)
    },
    //获取仓库设置
    getHouseSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/setting/getHouseSetting/${_params}`, _params, _success, _error)
    },
    //获取企业信息
    getCompany: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/home/noAuth/getCompany/${_params}`, _params, _success, _error)
    },
    // 获取客户分类列表
    findList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/client/clientType/findList`, _params, _success, _error)
    },
    // 获取首页信息
    getPageDataByWeb: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/decorate/noAuth/getPageDataByWeb`, _params, _success, _error)
    },
    // 获取店铺装修商品
    searchListForDecorate: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/decorate/noAuth/searchListForDecorate`, _params, _success, _error)
    },
    // 批量查询楼层商品（性能优化：一次请求查询多个楼层）
    batchSearchListForDecorate: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/decorate/noAuth/batchSearchListForDecorate`, _params, _success, _error)
    },
    updateClientLastVisitedTime: (_params, _success, _error) => {
        _request('POST', `${API}/v1/decorate/wpShopTemplate/noAuth/updateClientLastVisitedTime/${_params}`, _params, _success, _error)
    },
    // 获取店铺装修商品
    countDecorateVisitor: (_params, _success, _error) => {
        _request('POST', `${API}/v1/decorate/wpShopTemplate/noAuth/countVisitor/${_params}`, _params, _success, _error)
    },
    // 获取店铺装修促销
    listForGoodsPromotionActivityIds: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/decorate/noAuth/listForGoodsPromotionActivityIds`, _params, _success, _error)
    },
    //查询指定商品当前应用的促销
    goodsPromotionByGoods: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/goodsPromotion/listByGoods/${_params}`, _params, _success, _error)
    },
    //查询促销列表
    searchListActivityForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/goodsPromotion/noAuth/searchListActivityForShop`, _params, _success, _error)
    },
    //获取运费计算设置
    // getShipFeeSettingByLogin: (_params, _success, _error) => {
    //     _request('GET', `${API}/v1/setting/shipFeeSetting/getByLoginUser/${_params}`, _params, _success, _error)
    // },
    //获取运费计算设置
    getShipFeeSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/shipFeeSetting/shopGetAllShipFeeSetting/${_params}`, _params, _success, _error)
    },
    //获取运费计算设置
    getShipFeeSettingByLogin: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/shipFeeSetting/getAllShipFeeSetting/${_params}`, _params, _success, _error)
    },
    //获取客户优惠券
    listCouponByShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/coupon/listCouponByShop`, _params, _success, _error)
    },
    //获取客户相关优惠券活动
    listCouponActivityByShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/coupon/listCouponActivityByShop`, _params, _success, _error)
    },
    //领取优惠券
    receiveCoupon: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/coupon/receiveCoupon`, _params, _success, _error)
    },
    //批量领取优惠券
    batchReceiveCoupon: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/coupon/batchReceiveCoupon`, _params, _success, _error)
    },
    //获取预存款明细
    searchPreBalanceListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/searchPreBalanceListForShop`, _params, _success, _error)
    },
    // 获取返款账户明细
    searchRebatesBalanceListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/finance/clientRebatesBalanceRecord/searchRebatesBalanceListForShop`, _params, _success, _error)
    },
    //记录浏览商品足迹
    saveGoodsViewLog: (_params, _success, _error) => {
        _request('POST', `${API}/v1/goods/goodsViewLog/save`, _params, _success, _error)
    },
    //获取浏览商品足迹
    searchViewLogListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/goods/goodsViewLog/searchViewLogListForShop`, _params, _success, _error)
    },
    //刪除足迹
    deleteViewLogListByIds: (_params, _success, _error) => {
        _request('DELETE', `${API}/v1/goods/goodsViewLog/deleteByIds/${_params}`, _params, _success, _error)
    },
    //获取推荐商品
    searchRecommendedGoodsListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/searchRecommendedGoodsListForShop`, _params, _success, _error)
    },
    //获取商品套餐列表
    searchGoodsPackageListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/searchGoodsPackageListForShop`, _params, _success, _error)
    },
    //获取商品套餐详情
    getGoodsPackageByIdForWeb: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/getGoodsPackageByIdForWeb/${_params}`, _params, _success, _error)
    },

    //查询客户是否申请注销
    cancelInfoByClientId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shopRegisterSetting/cancelInfoByClientId/${_params}`, _params, _success, _error);
    },
    //新增注销记录
    saveCancel: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shopRegisterSetting/saveCancel`, {_meth: 'body', ..._params}, _success, _error)
    },
};
//购物车模块接口
export const CartFetch = {
    //保存/修改商城购物车列表
    saveCart: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/cart/updateForShop`, _params, _success, _error)
    },
    //webapp再来一单添加商品合并到购物车
    mergeCartForWeb: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/cart/mergeCartForWeb`, _params, _success, _error)
    },
    //修改商城购物车列表
    updateCart: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/cart/updateForWeb`, _params, _success, _error)
    },
    //购物车查询
    searchListForShopCart: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/cart/searchListForShopCart`, _params, _success, _error)
    },
    //修改商城购物车数量
    modifyCartNum: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/cart/modifyCartNum`, _params, _success, _error)
    },
    //删除商城购物车
    batchDelete: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/cart/batchDelete`, _params, _success, _error)
    },
    //列出企业配置的配送方式
    listShipWay: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/noAuth/listShipWay`, _params, _success, _error)
    },
    //获取送货地址--代客下单
    clientAddress: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/valetSale/listByClientId/${_params}`, _params, _success, _error)
    },
    //获取发票类型
    getSaleSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/setting/getSaleSetting/` + _params, _params, _success, _error)
    },
    //保存订单
    batchSave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/batchSave`, _params, _success, _error)
    },
    //保存订单
    save: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/save`, {_meth: 'body', ..._params}, _success, _error)
    },
    //保存预售订单
    presaleSave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/presaleSave`, {_meth: 'body', ..._params}, _success, _error)
    },
    //获取商品优惠信息
    getPromotionByGoodsId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/goodsPromotion/getPromotionByGoodsId`, _params, _success, _error)
    },
    //根据规格ids串获取商品优惠信息
    getPromotionByProductIds: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/goodsPromotion/getPromotionByProductIds`, _params, _success, _error)
    },
    batchGetPromotionByProductIds: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sale/goodsPromotion/batchGetPromotionByProductIds`, _params, _success, _error)
    },
    //获取商品优惠信息
    getPromotionByProductId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/goodsPromotion/getPromotionByProductId`, _params, _success, _error)
    },
    //获取商品优惠信息
    getActivityById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/goodsPromotion/getActivityById/${_params}`, null, _success, _error)
    },
    //获取订单优惠信息
    getPromotionByCompanyId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/orderPromotion/getPromotionByCompanyId`, _params, _success, _error)
    },
    batchGetPromotionByCompanyIds: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/orderPromotion/batchGetPromotionByCompanyIds`, _params, _success, _error)
    },
    //获取购物车SKU总数量
    sumNumber: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/cart/sumNumber`, _params, _success, _error)
    },
    //清除购物车下架商品
    cleanDownawayGoods: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/cart/cleanDownawayGoods`, _params, _success, _error)
    },
    //批量添加商城商品收藏
    batchAddGoodsFavorite: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/goodsFavorite/batchAddGoodsFavorite`, _params, _success, _error)
    },
    //合并订单
    combinedPaySave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/finance/combinedPay/save`, _params, _success, _error)
    },
    //合并订单
    combinedPayGetById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/finance/combinedPay/getById/${_params}`, _params, _success, _error)
    },
    //获取优惠券活动
    getCouponActivityById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/coupon/getCouponActivityById/${_params}`, _params, _success, _error)
    },
    getCouponRecordById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/coupon/getCouponRecordById/${_params}`, _params, _success, _error)
    },

    //获取商品预售信息
    getpresalePromotionByGoodsId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/presalePromotion/getPromotionByGoodsId`, _params, _success, _error)
    },
    //获取商品预售信息
    getPresalePromotionByProductIds: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/presalePromotion/getPromotionByProductIds`, _params, _success, _error)
    },
    //获取预售活动信息
    getPresalePromotionById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/presalePromotion/getActivityById/${_params}`, _params, _success, _error)
    },
    //购物车商品缓存添加
    batchSaveCartCache: (_params, _success, _error) => {
        _request('POST', `${API}/v1/goods/goodsToCartCache/batchSave`, {..._params}, _success, _error)
    },
    //购物车商品缓存
    searchListForShopCartCache: (_params, _success, _error) => {
        _request('GET', `${API}/v1/goods/goodsToCartCache/searchListForShop`, _params, _success, _error)
    },
    //购物车商品缓存
    deleteByEditCartCache: (_params, _success, _error) => {
        _request('GET', `${API}/v1/goods/goodsToCartCache/deleteByEdit`, _params, _success, _error)
    },
    //购物车商品缓存
    cleanByclientIdCartCache: (_params, _success, _error) => {
        _request('DELETE', `${API}/v1/goods/goodsToCartCache/cleanByclientId/${_params}`, _params, _success, _error)
    },
};
//商城订单
export const OrderFetch = {
    //保存/修改商城购物车列表
    getById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/getById/` + _params, _params, _success, _error)
    },
    // 获取订单详情
    getSaleOrderById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/saleOrder/getById/` + _params, _params, _success, _error)
    },
    //订单支付(线下或预付款)
    orderPay: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/orderPayByOfflineOrPre`, {_meth: 'body', ..._params}, _success, _error)
    },
    //订单支付(线下或预付款)
    getPreBalance: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/getPreBalance`, _params, _success, _error)
    },
    //
    searchListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/searchListForShop`, _params, _success, _error)
    },
    //取消订单
    orderCancel: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/cancel`, _params, _success, _error)
    },
    //删除订单
    deleteOrderById: (_params, _success, _error) => {
        _request('DELETE', `${API}/v1/shop/order/deleteById/${_params}`, _params, _success, _error)
    },
    //删除订单
    markNotViewForShop: (_params, _success, _error) => {
        _request('DELETE', `${API}/v1/shop/order/markNotViewForShop/${_params}`, _params, _success, _error)
    },
    //确认收货
    receiveById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/batchReceive/${_params}`, _params, _success, _error)
    },
    //确认收货
    receive: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/receive`, {..._params, _meth: 'body'}, _success, _error)
    },
    // 根据快递单号获取物流信息
    getLogisticInfo: (_params, _success, _error) => {
        _request('GET', `${API}/v1/common/helper/getLogisticInfo`, _params, _success, _error)
    },
    // 获取企业线下收款账号
    listOfflineAccount: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/listOfflineAccount`, _params, _success, _error)
    },
    // 获取企业线下收款账号
    listAccount: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/listAccount`, _params, _success, _error)
    },
    // 获取企业线上收款账号
    listOnlineAccount: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/listOnlineAccount`, _params, _success, _error)
    },
    orderPayByOfflineOrPre: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/orderPayByOfflineOrPre`, _params, _success, _error);
    },
    // 分页获取商城订单消息列表
    searchOrderMessage: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/orderMessage/searchListByLogin`, _params, _success, _error)
    },
    // 标记订单消息为已读
    markRead: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/orderMessage/markRead/${_params}`, null, _success, _error);
    },
    // 标记订单消息为全部已读
    markAllRead: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/orderMessage/markAllRead`, _params, _success, _error);
    },
    //获取收款单核销记录
    findSaleOrderIncomeList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/finance/income/noAuth/findSaleOrderIncomeList/${_params}`, _params, _success, _error)
    },
    //修改销售单商品备注
    modifyItemRemark: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/modifyItemRemark`, _params, _success, _error)
    },
    //客户订货统计（最近两年）
    clientSaleReport: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/clientSaleReport`, _params, _success, _error)
    },
    // 规格销售报表-按规格统计列表
    productSaleReportSearchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/productSaleReportSearchList`, _params, _success, _error)
    },
    // 分类销售报表-按分类统计列表
    goodsTypeSaleReportSearchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/order/goodsTypeSaleReportSearchList`, _params, _success, _error)
    },
    // 添加日志
    saveOrderLog: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/saveOrderLog`, {_meth: 'body', ..._params}, _success, _error)
    },
    //
    getOrderMoneyRestrictDto: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/saleOrder/getOrderMoneyRestrictDto/${_params}`, _params, _success, _error)
    },
    // 申请开票
    updateOrderTaxRate: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sale/saleOrder/updateOrderTaxRate`, {_meth: 'body', ..._params}, _success, _error)
    },

};
//系统模块
export const System = {
    saveClientInquiry: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sl/clientInquiry/save`, {_meth: 'body', ..._params}, _success, _error)
    },
    editShopPopCheckCount: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sl/homePagePop/editCheckCount/${_params}`, _params, _success, _error)
    },
    getPopInfo: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sl/homePagePop/getPopInfo`, _params, _success, _error)
    },
    cooperateApplySave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/bs/upstreamApply/save`, {_meth: 'body', ..._params}, _success, _error)
    },
    joinApplySave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/bs/joinApply/save`, {_meth: 'body', ..._params}, _success, _error)
    },
    getPartnerJoinInfo: (_params, _success, _error) => {
        _request('GET', `${API}/v1/bs/partnerJoinSetting/getPartnerJoinInfo`, _params, _success, _error)
    },
    // 获取客服列表
    getCustomerServiceList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/client/client/getCustomerServiceList`, _params, _success, _error)
    },

    getMsgSettingByCompanyId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/bs/msgSetting/getByCompanyId`, _params, _success, _error)
    },

    // 根据国家获取税费
    getTaxById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/bs/regionEx/getById/${_params}`, _params, _success, _error)
    },
    // 根据国家获取运费
    getEconomizeById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/bs/regionShippingFee/getByEconomizeId/${_params}`, _params, _success, _error)
    },
    searchListQuotationDetails: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sl/quotationOrderItem/searchListQuotationDetails`, _params, _success, _error)
    },
    saveCreditQuotaApply: (_params, _success, _error) => {
        _request('POST', `${API}/v1/application/creditQuota/saveCreditQuotaApply`, {_meth: 'body', ..._params}, _success, _error)
    },
    findNoCreditApplyClientList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/client/client/findNoCreditApplyClientList`, _params, _success, _error)
    },
    buildSimpleRegionExTree: (_params, _success, _error) => {
        _request('GET', `${API}/v1/common/helper/buildSimpleRegionExTree/${_params}`, _params, _success, _error)
    },
    searchCountryRegionExList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/bs/regionEx/searchCountryRegionExList`, _params, _success, _error)
    },
    getExchangeRate: (_params, _success, _error) => {
        _request('POST', `${API}/v1/bs/wbRmbClient/isExchangeRate`, _params, _success, _error)
    },
    getCompany: (_params, _success, _error) => {
        _request('GET', `${API}/v1/base/company/getById/${_params}`, _params, _success, _error)
    },
    getCompanySetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/base/company/getCompanyShop1Setting`, _params, _success, _error)
    },
    //订货端获取企业设置
    getShopCompanySetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/setting/getShopCompanySetting/${_params}`, _params, _success, _error)
    },
    //管理端-第一步点击就记录体验信息-体验
    experienceRegister: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/experienceRegister`, _params, _success, _error)
    },
    //管理端-体验
    experience: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/getExperienceUser`, {..._params, type_: 1}, _success, _error)
    },
    //订货端-体验
    shopExperience: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/getExperienceUser`, {..._params, type_: 2}, _success, _error)
    },
    //登陆
    login: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/login`, _params, _success, _error)
    },
    //混合登陆（兼容账号跟手机号去登陆）
    loginMixed: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/mixedLogin`, _params, _success, _error)
    },
    //登陆
    logout: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/account/noAuth/logout`, _params, _success, _error)
    },
    //验证验证码
    checkRegistCode: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/checkRegistCode`, _params, _success, _error)
    },
    //创建企业
    createCompany: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/createCompany`, _params, _success, _error)
    },
    //获取重置密码验证码
    resetCode: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/noAuth/resetCode`, _params, _success, _error)
    },
    //发送注册验证码
    registCode: (_params, _success, _error) => {
        _request('GET', `${API}/v1/account/registCode`, _params, _success, _error)
    },
    //发送注册验证码--pc分享出来的注册
    registCodeNoAuth: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/noAuth/registCode`, _params, _success, _error)
    },
    //校验注册验证码--pc分享出来的注册
    checkNoAuthRegistCode: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/account/noAuth/checkRegistCode`, _params, _success, _error)
    },
    //快速注册-订货端注册优化优化
    checkQuickRegistCode: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/account/noAuth/quickRegist`, _params, _success, _error)
    },
    //绑定刚注册的账号--pc分享出来的注册，完成注册后继续绑定
    completeNoAuthRegist: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/account/noAuth/completeRegist`, _params, _success, _error)
    },
    //发送绑定验证码
    bindCode: (_params, _success, _error) => {
        _request('GET', `${API}/v1/base/user/bindPhoneCode`, _params, _success, _error)
    },
    //验证绑定手机的验证码
    checkBindCode: (_params, _success, _error) => {
        _request('POST', `${API}/v1/base/user/checkBindPhoneCode`, _params, _success, _error)
    },
    //绑定手机号
    bindPhone: (_params, _success, _error) => {
        _request('POST', `${API}/v1/base/user/bindPhone`, _params, _success, _error)
    },
    //订货端重置密码
    resetPasswordByShop: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/account/noAuth/resetPasswordByShop`, _params, _success, _error)
    },
    //获取重置密码验证码---管理端
    resetCodeByManager: (_params, _success, _error) => {
        _request('GET', `${API}/v1/account/resetCode`, _params, _success, _error)
    },
    //管理端重置密码---管理端
    resetPasswordByManager: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/resetPassword`, _params, _success, _error)
    },
    //获取登陆用户信息
    getClientInfo: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/getClientInfo`, _params, _success, _error)
    },
    //获取登陆用户信息
    getClientById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/getClientById/${_params}`, _params, _success, _error)
    },
    //设置默认地址
    getUserInfo: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/getShopUserInfo`, _params, _success, _error)
    },
    // 保存用户客户信息
    saveUserClientInfo: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/account/saveUserClientInfo`, _params, _success, _error)
    },
    // 保存用户头像
    updateUserHeadImg: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/account/updateUserHeadImg`, _params, _success, _error)
    },
    //获取商品设置信息
    getGoodsSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/goodsSetting/getByCompanyId/${_params}`, _params, _success, _error)
    },
    //获取销售设置信息
    getSaleSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/setting/getSaleSetting`, _params, _success, _error)
    },
    // 获取文件上传的token信息
    getUploadToken: (_params, _success, _error) => {
        _request('GET', `${API}/v1/common/upload/getUploadToken`, _params, _success, _error)
    },
    // 获取公司基本信息
    getCompanyInfo: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/getCompanyById/` + _params, _params, _success, _error)
    },
    //取当前登录人关联的所有账号信息列表
    getAccountList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/base/user/getAccountList`, _params, _success, _error)
    },
    //获取客户关联的员工列表
    getStaffList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/base/user/searchList`, _params, _success, _error)
    },
    // 获取商城主题
    getThemeSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/setting/getThemeSetting/${_params}`, _params, _success, _error)
    },
    //获取当前登录用户的authCode
    getAuthCode: (_params, _success, _error) => {
        _request('GET', `${API}/v1/account/getAuthCode`, _params, _success, _error)
    },
    //获取当前登录用户的authCode
    getMobileShopVersion: (_params, _success, _error) => {
        _request('GET', `${API}/v1/account/getMobileShopVersion`, _params, _success, _error)
    },
    //获取省市县
    buildRegionTree: (_params, _success, _error) => {
        _request('GET', `${API}/v1/common/helper/buildRegionTree`, _params, _success, _error)
    },
    buildSimpleRegionTree: (_params, _success, _error) => {
        _request('GET', `${API}/v1/common/helper/buildSimpleRegionTree`, _params, _success, _error)
    },
    //获取微信jsticket
    getWxTicket: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/noAuth/getWxTicket`, _params, _success, _error)
    },
    //获取微信jsticket/
    getWxQrcode: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/noAuth/getWxQrCode`, _params, _success, _error)
    },
    //获取分享设置
    getShareSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/getShareSetting`, _params, _success, _error)
    },
    //保存分享设置
    saveShareSetting: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/account/saveShareSetting`, _params, _success, _error)
    },
    // 添加客服消息
    addMsgForClient: (_params, _success, _error) => {
        _request('POST', `${API}/v1/client/client/addMsgForClient`, _params, _success, _error)
    },
    // 获取指定对话消息列表
    searchMsgList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/client/client/searchMsgList`, _params, _success, _error)
    },
    // 获取指定对话消息列表
    markReadByClient: (_params, _success, _error) => {
        _request('POST', `${API}/v1/client/client/markReadByClient/${_params}`, _params, _success, _error)
    },
    // 获取消息对话列表
    searchGroupMsgListForClient: (_params, _success, _error) => {
        _request('GET', `${API}/v1/client/client/searchGroupMsgListForClient`, _params, _success, _error)
    },
    // 关键词搜索
    searchKeyWordList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/goods/noAuth/searchKeyWordList`, _params, _success, _error)
    },

    // 个人中心
    getShopUserInfoForHome: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/account/getShopUserInfoForHome`, _params, _success, _error)
    },
    // 获取商城帮助
    shopHelpTypeSearchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shopHelp/shopHelpType/noAuth/searchListForShop`, _params, _success, _error)
    },
    // 获取微信用户信息
    getWeChatUserInfo: (_params, _success, _error) => {
        _request('GET', `${API}/v1/setting/weChatSetting/noAuth/getWeChatUserInfo`, _params, _success, _error)
    },
    // 微信openId登录
    openIdLogin: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/openIdLogin`, _params, _success, _error)
    },
    // 绑定微信openId
    bindOpenId: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/bindOpenId`, _params, _success, _error)
    },
    // 登录并绑定微信openId
    bindOpenIdForLogin: (_params, _success, _error) => {
        _request('POST', `${API}/v1/account/bindOpenIdForLogin`, _params, _success, _error)
    },
    // 保存/修改商城注册记录
    shopRegisterSave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shopRegister/noAuth/save`, {_meth: 'body', ..._params}, _success, _error)
    },
    //
    getApplicationStatus: (_params, _success, _error) => {
        _request('GET', `${API}/v1/application/noAuth/getApplicationStatus`, _params, _success, _error)
    },
    //订单发票统计列表
    searchOrderInvoiceCountList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/invoice/invoiceLog/searchOrderInvoiceCountList`, _params, _success, _error)
    },
    //订单发票统计列表
    searchInvoiceLogMap: (_params, _success, _error) => {
        _request('POST', `${API}/v1/invoice/invoiceLog/searchInvoiceLogMap`, {
            ..._params,
            _meth: 'body'
        }, _success, _error)
    },
    //订单发票详情
    getInvoiceById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/invoice/invoiceLog/getById/${_params}`, _params, _success, _error)
    },
    //获取AuthCode
    getOpenAuthCode: (_params, _success, _error) => {
        _request('GET', `${API}/openapi/v1/auth/getAuthCode`, _params, _success, _error);
    },
};
//支付模块接口
export const PayFetch = {
    getOrderInfoForStripe: (_params, _success, _error) => {
        _request('GET', `${API}/v1/stripePay/apply/noAuth/getOrderInfo`, _params, _success, _error)
    },
    //stripe
    createPaymentForStripe: (_params, _success, _error) => {
        _request('GET', `${API}/v1/stripePay/apply/createPaymentIntent`, _params, _success, _error)
    },
    palPay: (_params, _success, _error) => {
        _request('GET', `${API}/v1/paypal/notify/noAuth/paySuccess1`, _params, _success, _error)
    },
    //PayPal
    createOrderByPayPal: (_params, _success, _error) => {
        _request('GET', `${API}/v1/paypal/apply/createOrder`, _params, _success, _error)
    },
    //构建支付宝支付参数
    buildWebAlipayApi: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/pay/buildWebAlipayApi`, {_meth: 'body', ..._params}, _success, _error)
    },
    //构建订单合并支付支付宝支付请求
    buildCombinedPayWebAlipayApi: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/pay/buildCombinedPayWebAlipayApi`, _params, _success, _error)
    },
    //微信公众号支付
    pubWeixinApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/pay/pubWeixinApi`, _params, _success, _error)
    },
    weixinH5Api: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/pay/noAuth/weixinH5Api`, _params, _success, _error)
    },
    //微信外h5订单合并支付
    weixinCombinedPayH5Api: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/pay/weixinCombinedPayH5Api`, _params, _success, _error)
    },
    // 合并付款 公众号支付
    weixinCombinedPayApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/pay/weixinCombinedPayApi`, _params, _success, _error)
    },
    //合并付款预存款和线下付
    combinedPayByOfflineOrPre: (_params, _success, _error) => {
        _request('POST', `${API}/v1/finance/combinedPay/combinedPayByOfflineOrPre`, _params, _success, _error)
    },
    //构建预存款充值支付宝支付请求
    buildPreBalanceRechargeAlipayApi: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/pay/buildPreBalanceRechargeAlipayApi`, {_meth: 'body', ..._params}, _success, _error)
    },
    //预存款充值微信外h5支付
    weixinPreBalanceRechargeH5Api: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/pay/weixinPreBalanceRechargeH5Api`, _params, _success, _error)
    },
    //预存款充值微信公众号支付
    pubPreBalanceRechargeWeixinApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/pay/pubPreBalanceRechargeWeixinApi`, _params, _success, _error)
    },
    // 组合支付
    combinationPay: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/order/combinationPay`, {_meth: 'body', ..._params}, _success, _error)
    },
    //获取支付状态
    getPayFinanceStatus: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/pay/getPayFinanceStatus`, _params, _success, _error)
    },
    // 京东支付h5收银台
    jdOrderH5Cashier: (_params, _success, _error) => {
        _request('POST', `${API}/v1/jdPay/apply/noAuth/orderH5Cashier`, {_meth: 'body', ..._params}, _success, _error)
    },
    jdOrderH5CashierV2: (_params, _success, _error) => {
        _request('POST', `${API}/v2/jdPay/apply/orderH5Cashier`, {_meth: 'body', ..._params}, _success, _error)
    },
    // 预存款充值h5收银台
    preBalanceRechargeH5Cashier: (_params, _success, _error) => {
        _request('POST', `${API}/v1/jdPay/apply/preBalanceRechargeH5Cashier`, {_meth: 'body', ..._params}, _success, _error)
    },
    // 合并支付h5收银台
    combinedH5Cashier: (_params, _success, _error) => {
        _request('POST', `${API}/v1/jdPay/apply/combinedH5Cashier`, {_meth: 'body', ..._params}, _success, _error)
    },
    //查询是否开通产品类别
    checkPayType: (_params, _success, _error) => {
        _request('GET', `${API}/v1/jdPay/merchant/checkPayType`, _params, _success, _error)
    },
    //查询是否开通产品类别
    getJdAccountByClientId: (_params, _success, _error) => {
        _request('POST', `${API}/v1/fn/jdAccount/noAuth/getByClientId`, {_meth: 'body', ..._params}, _success, _error)
    },

};
//代客下单
export const ClientFetch = {
    //创建订单
    saveByClient: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sale/valetSale/saveByClient`, _params, _success, _error)
    },
    //根据规格ids串获取商品优惠信息
    getPromotionByProductIdsByClient: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/valetSale/getPromotionByProductIdsByClient`, _params, _success, _error)
    },
    //获取订单优惠信息
    getPromotionByClient: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/valetSale/getPromotionByClient`, _params, _success, _error)
    },
    //商城商品分页查询
    searchListForShopByClient: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/valetSale/noAuth/searchListForShopByClient`, _params, _success, _error)
    },
    //客户列表
    searchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/client/client/searchList`, _params, _success, _error)
    },
    //新增客户
    addNewClient: (_params, _success, _error) => {
        _request('POST', `${API}/v1/client/client/save`, _params, _success, _error)
    },
    // 获取商城主题
    companyShopToMgr: (_params, _success, _error) => {
        _request('POST', `${API}/v1/client/companyShop/toMgr/${_params}`, _params, _success, _error)
    },
};

export const ApplicationFetch = {
    getMiniProgram: (_params, _success, _error) => {
        _request('GET', `${API}/v1/application/miniProgram/noAuth/getByCompanyId/${_params}`, _params, _success, _error)
    }
};
//积分商城模块
export const IntegralFetch = {
    //分页获取积分商品表列表
    searchList: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/score/goods/searchList`, _params, _success, _error)
    },
    //分页获取积分商品表列表
    getById: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/score/goods/getById/${_params}`, _params, _success, _error)
    },
    //获取积分商品分类列表
    listAll: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/score/goods/listAllType`, _params, _success, _error)
    },
    //获取我的积分信息
    getMyScore: (_params, _success, _error) => {
        _request('GET', `${API}//api/v1/buyer/mine/getMyScore`, _params, _success, _error)
    },
    //获取我的积分明细列表
    getMyScoreLog: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/buyer/mine/getMyScoreLog`, _params, _success, _error)
    },
    //获取积分规则设置
    getRulesSetting: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/buyer/mine/getRulesSetting`, _params, _success, _error)
    },
    //创建积分订单
    createOrder: (_params, _success, _error) => {
        _request('POST', `${API}/api/v1/score/order/createOrder`, _params, _success, _error)
    },
    //分页获取积分订单信息列表
    searchOrderList: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/score/order/searchList`, _params, _success, _error)
    },
    //获取积分订单信息
    getOrderById: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/score/order/getById/${_params}`, _params, _success, _error)
    },
    //根据快递单号获取物流信息
    getLogisticInfo: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/common/data/getLogisticInfo`, _params, _success, _error)
    },
    //根据快递单号获取物流信息
    getMySign: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/buyer/mine/getMySign`, _params, _success, _error)
    },
    //签到
    sign: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/buyer/mine/sign`, _params, _success, _error)
    },
    //签到
    getScoreCompanySetting: (_params, _success, _error) => {
        _request('GET', `${API}/api/v1/buyer/mine/getScoreCompanySetting`, _params, _success, _error)
    },
};
// 退货
export const SaleBackFetch = {
    // 申请退货
    save: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sale/saleBack/save`, {_meth: 'body', ..._params}, _success, _error)
    },
    // 退货列表
    searchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/saleBack/searchList`, _params, _success, _error)
    },
    // 退货列表
    getById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/saleBack/getById/${_params}`, _params, _success, _error)
    },
    // 退货原因
    getSaleBackReasonList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/saleBack/searchListForSaleBackReason`, _params, _success, _error)
    },
};
// 销售中心
export const DistributionFetch = {
    //客户信息
    getByClientId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/distribution/distributionClientData/getByClientId/${_params}`, _params, _success, _error)
    },
    //手机端客户分销销售中心统计数据
    getCountDateByClientId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/distribution/distributionClientData/getCountDateByClientId/${_params}`, _params, _success, _error)
    },
    //手机端客户业绩统计
    getPerformanceStatistics: (_params, _success, _error) => {
        _request('GET', `${API}/v1/distribution/distributionClientData/getPerformanceStatistics/${_params}`, _params, _success, _error)
    },
    //我的客户统计
    searchChildenClientList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/distribution/distributionClientData/searchChildenClientList`, _params, _success, _error)
    },
    //订单统计
    searchOrderList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/distribution/distributionRebate/searchList`, _params, _success, _error)
    },
    //保存提现账号
    saveAccount: (_params, _success, _error) => {
        _request('POST', `${API}/v1/distribution/distributionClientData/save`, _params, _success, _error)
    },
    //提现
    distributionWithdrawalSave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/distribution/distributionWithdrawal/save`, _params, _success, _error)
    },
    //提现
    transferToFinance: (_params1, _params2, _success, _error) => {
        _request('POST', `${API}/v1/distribution/distributionWithdrawal/transferToFinance/${_params1}/${_params2} `, _params1, _success, _error)
    },
    //账户明细
    searchLogList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/distribution/distributionPayLog/searchList`, _params, _success, _error)
    },
    //提现记录
    searchLWithdrawalLogList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/distribution/distributionWithdrawal/searchList`, _params, _success, _error)
    },
    //设置客户上级客户
    saveParentClient: (_params, _success, _error) => {
        _request('POST', `${API}/v1/distribution/distributionClientData/saveParentClient`, _params, _success, _error)
    },
    //推广商品列表
    searchListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/distribution/distributionRebate/noAuth/searchListForShop`, _params, _success, _error)
    },
    //最高佣金
    getGoodsCommissionById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/distribution/distributionRebate/noAuth/getGoodsById/${_params}`, _params, _success, _error)
    },
};
// 预存款
export const DepositFetch = {
    checkClientBalance: (_params, _success, _error) => {
        _request('GET', `${API}/v1/fn/rechargeDeduct/checkClientBalance`, _params, _success, _error)
    },
    save: (_params, _success, _error) => {
        _request('POST', `${API}/v1/fn/rechargeDeduct/save`, {_meth: 'body', ..._params}, _success, _error)
    },
    //查询企业的预存款充值设置明细
    searchItemListByLogin: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/preBalanceRecharge/searchItemListByLogin`, _params, _success, _error)
    },
    //申请预存款充值充值
    applyRecharge: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/preBalanceRecharge/applyRecharge`, {_meth: 'body', ..._params}, _success, _error)
    },
    // 查询存款充值记录
    getById: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/preBalanceRecharge/getById/${_params}`, _params, _success, _error)
    },
};
// 代金券接口
export const VouchersFetch = {
    // 获取代金券列表
    searchClientVouchersList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/vouchers/vouchers/searchClientVouchersList`, _params, _success, _error)
    },
    // 更新代金券列表
    updateIsReadByIds: (_params, _success, _error) => {
        _request('GET', `${API}/v1/vouchers/vouchers/updateIsReadByIds/${_params}`, _params, _success, _error)
    },
    // 获取代金券明細
    searchVouchersLog: (_params, _success, _error) => {
        _request('GET', `${API}/v1/vouchers/vouchersLog/searchList`, _params, _success, _error)
    },
    // 根据商品获取代金券
    searchListByGoodsIdAndClientId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/vouchers/vouchers/searchListByGoodsIdAndClientId`, _params, _success, _error)
    },
    // 根据规格获取代金券
    searchListByProductIdAndClientId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/vouchers/vouchers/searchListByProductIdAndClientId`, _params, _success, _error)
    },
};
// 代金券接口
export const ClientAddressFetch = {
    //获取送货地址
    listAddress: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/address/listByLoginUser`, _params, _success, _error)
    },
    //保存、修改地址
    saveAddress: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/address/save`, {..._params, _meth: 'body'}, _success, _error)
    },
    //获取地址
    deleteAddress: (_params, _success, _error) => {
        _request('DELETE', `${API}/v1/shop/address/deleteById/${_params}`, _params, _success, _error)
    },
    //设置默认地址
    setDefault: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/address/setDefault/${_params}`, _params, _success, _error)
    },
};
//线下体验馆模块
export const ExperienceFetch = {
    //分页获取线下体验馆列表
    searchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/store/experienceShop/searchList`, _params, _success, _error)
    },
    //分页获取省市区列表
    searchRegionList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/common/helper/searchRegionList`, _params, _success, _error)
    },
    //获取线下体验馆
    getById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/store/experienceShop/getById/${_params}`, _params, _success, _error)
    },

};
//授信
export const CreditQuotaFetch = {
    //客户申请授信
    saveQuotaApply: (_params, _success, _error) => {
        _request('POST', `${API}/v1/application/creditQuota/saveCreditQuotaApply`, {
            ..._params,
            _meth: 'body'
        }, _success, _error)
    },
    selectExistQuotationOrderByClient: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sl/quotationOrder/selectExistQuotationOrderByClient`, {
            ..._params,
            _meth: 'body'
        }, _success, _error)
    },
    //客户申请授信
    getQuotaApplyById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/application/creditQuota/getCreditQuotaApplyByClientId`, _params, _success, _error)
    },
    //分页获取授信额度变更列表
    searchLogListForShop: (_params, _success, _error) => {
        _request('GET', `${API}/v1/application/creditQuota/searchLogListForShop`, _params, _success, _error)
    },
};
// 免费领
export const FreeGoodsFetch = {
    //购物车查看对应客户类型可参与的免费活动信息
    freeActivityByClientType: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sl/freeGoodsActivity/freeActivityByClientType`, _params, _success, _error)
    },
};
// 串号查询
export const GoodsSnFetch = {
    searchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/hs/goodsSnCheck/searchList`, _params, _success, _error)
    },
    //查询指定企业串号查询设置, 企业id为空时,企业id=登录用户企业
    getSearchSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/house/goodsSnSearchSetting/noAuth/getSearchSetting`, _params, _success, _error)
    },
    //精确查询串号信息, 企业id为空时,企业id=登录用户企业
    getByCode: (_params, _success, _error) => {
        _request('GET', `${API}/v1/house/goodsSn/noAuth/getByCode`, _params, _success, _error)
    },
    checkGoodsSn: (_params, _success, _error) => {
        _request('GET', `${API}/v1/hs/goodsSnCheck/checkGoodsSn`, _params, _success, _error)
    },
    save: (_params, _success, _error) => {
        _request('POST', `${API}/v1/hs/goodsSnCheck/save`, {..._params, _meth: 'body'}, _success, _error)
    },

};
// 自提点
export const PickUpStationFetch = {
    //分页查询自提点
    searchList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/house/selfPickSite/searchListForShop`, _params, _success, _error)
    },
    //客户默认自提点
    getClientDefaultSite: (_params, _success, _error) => {
        _request('POST', `${API}/v1/house/selfPickSite/getClientDefaultSite/${_params}`, _params, _success, _error)
    },
};

export const AggregatePayFetch = {
    //获取聚合配置信息
    getByType: (_params, _success, _error) => {
        _request('POST', `${API}/v1/finance/aggregatePayConfig/noAuth/getByType`, {..._params, _meth: 'body'}, _success, _error)
    },
    //微信外请求微信小程序唤醒微信小程序支付
    buildWeixinMiniProgramUrlLink: (_params, _success, _error) => {
        _request('GET', `${API}/v1/yiShengPay/apply/buildWeixinMiniProgramUrlLink`, _params, _success, _error)
    },
    //微信外请求微信小程序唤醒微信小程序支付 京东支付
    jdPayBuildWeixinMiniProgramUrlLink: (_params, _success, _error) => {
        _request('POST', `${API}/v1/jdPay/apply/buildWeixinMiniProgramUrlLink`, {
            ..._params,
            _meth: 'body'
        }, _success, _error)
    },
    //微信外请求微信小程序唤醒微信小程序支付 京东支付
    buildWechatMiniProgramUrlLinkForNative: (_params, _success, _error) => {
        _request('POST', `${API}/v1/jdPay/apply/buildWechatMiniProgramUrlLinkForNative`, {
            ..._params,
            _meth: 'body'
        }, _success, _error)
    },
    // H5单个支付
    h5PayApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/kuaiqian/apply/h5PayApi`, _params, _success, _error)
    },
    // H5合并支付
    h5CombinedPay: (_params, _success, _error) => {
        _request('GET', `${API}/v1/kuaiqian/apply/combinedH5PayApi`, _params, _success, _error)
    },
    // 快钱公众号支付
    orderPayApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/kuaiqian/apply/orderPayApi`, _params, _success, _error)
    },
    combinedPayApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/kuaiqian/apply/combinedPayApi`, _params, _success, _error)
    },
    sdkPayApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/kuaiqian/apply/sdkPayApi`, _params, _success, _error)
    },
    // H5单个支付
    huifuH5PayApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/huifu/apply/noAuth/orderPayApi`, _params, _success, _error)
    },
    h5HuiFucombinedPay: (_params, _success, _error) => {
        _request('GET', `${API}/v1/huifu/apply/combinedPayApi`, _params, _success, _error)
    },
    wxMiniPayApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/huifu/apply/wxMiniPayApi`, _params, _success, _error)
    },
    weiXinPayAppApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/huifu/apply/weiXinPayAppApi`, _params, _success, _error)
    },
    aliPayMiniPayApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/huifu/apply/aliPayMiniPayApi`, _params, _success, _error)
    },
    aliPayAppApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/huifu/apply/aliPayAppApi`, _params, _success, _error)
    },
    getHuifuAccount: (_params, _success, _error) => {
        _request('GET', `${API}/v1/finance/account/getAccountByType`, _params, _success, _error)
    },
    wxHuiFuMiniPayApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/huifu/apply/wxHuiFuMiniPayApi`, _params, _success, _error)
    },
    wxH5PreBalanceRechargeApi: (_params, _success, _error) => {
        _request('GET', `${API}/v1/huifu/apply/wxH5PreBalanceRechargeApi`, _params, _success, _error)
    },
};

// 行为分析模块接口
export const BehaviorFetch = {
    // 单事件上报
    track: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/behavior/track`, {_meth: 'body', ..._params}, _success, _error)
    },
    // 批量事件上报
    trackBatch: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/behavior/track/batch`, {_meth: 'body', ..._params}, _success, _error)
    },
    // 获取客户行为标签
    getTagsByClientId: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/behavior/tags/${_params}`, _params, _success, _error)
    },
    // 获取搜索热词
    getHotKeywords: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/behavior/hotKeywords`, _params, _success, _error)
    },
    // 获取加购未购列表
    getCartNoBuy: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/behavior/cartNoBuy`, _params, _success, _error)
    },
    // 获取客户行为画像
    getClientProfile: (_params, _success, _error) => {
        _request('GET', `${API}/v1/shop/behavior/profile/${_params}`, _params, _success, _error)
    },
    // 退订营销推送
    unsubscribe: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/behavior/unsubscribe`, _params, _success, _error)
    },
    // 取消退订
    cancelUnsubscribe: (_params, _success, _error) => {
        _request('POST', `${API}/v1/shop/behavior/cancelUnsubscribe`, _params, _success, _error)
    },
};

export const ConsignFetch = {
    searchPickUpProductList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/hs/pickUpGoods/searchPickUpProductList`, _params, _success, _error)
    },
    searchConsignProductList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/hs/consignManager/searchConsignProductList`, _params, _success, _error)
    },
    consignStockSave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/hs/consignManager/save`, {..._params, _meth: 'body'}, _success, _error)
    },
    pickUpGoodsSave: (_params, _success, _error) => {
        _request('POST', `${API}/v1/hs/pickUpGoods/save`, {..._params, _meth: 'body'}, _success, _error)
    },
    getPickUpGoodsById: (_params, _success, _error) => {
        _request('GET', `${API}/v1/hs/pickUpGoods/getById/${_params}`, _params, _success, _error)
    },
    searchGoodsManagerList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/hs/consignManager/searchGoodsManagerList`, _params, _success, _error)
    },
    searchPickUpGoodsList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/hs/pickUpGoods/searchListForShop`, _params, _success, _error)
    },
    getConsignManagerSetting: (_params, _success, _error) => {
        _request('GET', `${API}/v1/ap/consignManagerSetting/getByCompanyId`, _params, _success, _error)
    },
    //确认收货
    receive: (_params, _success, _error) => {
        _request('POST', `${API}/v1/hs/pickUpGoods/receive`, {..._params, _meth: 'body'}, _success, _error)
    },
};

// 砍价活动模块接口
export const BargainFetch = {
    // 根据订单获取可用活动
    getByOrder: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/bargainActivity/getByOrder/${_params}`, _params, _success, _error);
    },
    getByOrderNoAuth: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/bargainActivity/noAuth/getByOrder/${_params.order_id_}/${_params.company_id_}/${_params.client_id_}`, _params, _success, _error);
    },
    // 发起砍价
    joinActivity: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sale/bargainActivity/joinActivity`, {..._params, _meth: 'body'}, _success, _error);
    },
    // 帮好友砍价
    helpBargain: (_params, _success, _error) => {
        _request('POST', `${API}/v1/sale/bargainActivity/helpBargain`, {..._params, _meth: 'body'}, _success, _error);
    },
    // 通过分享码获取详情
    getByShareCodeByNoAuth: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/bargainActivity/noAuth/getByShareCode/${_params}`, _params, _success, _error);
    },
    // 通过分享码获取详情
    getByShareCode: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/bargainActivity/getByShareCode/${_params}`, _params, _success, _error);
    },
    // 获取我的砍价详情
    getMyBargain: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/bargainActivity/getMyBargain/${_params.activityId}/${_params.orderId}`, _params, _success, _error);
    },
    // 获取我的砍价活动列表
    getMyBargainList: (_success, _error) => {
        _request('GET', `${API}/v1/sale/bargainActivity/getMyBargainList`, null, _success, _error);
    },
    // 获取帮砍记录列表
    getHelpList: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/bargainActivity/getHelpList/${_params}`, _params, _success, _error);
    },
    // 查询订单砍价券
    getBargainCoupon: (_params, _success, _error) => {
        _request('GET', `${API}/v1/sale/bargainActivity/getBargainCoupon/${_params}`, _params, _success, _error);
    },
};

/**
 * fetch请求数据Model
 * @param _method   请求方法
 * @param  _url     请求url
 * @param _params   请求参数
 * @param _onSuccess    请求成功回调
 * @param _onError      请求失败回调
 */
function _request(_method, _url, _params, _onSuccess, _onError) {
    const isMobile = navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
    let token = '';
    try {
        token = JSON.parse(localStorage.getItem("token"))
    } catch (err) {
        token = localStorage.removeItem("token")
    }
    /**
     * params._meth === 'body' 兼容后端body实体传参
     * */

    var paramStr = "";
    // 性能优化：支持数组参数作为JSON body发送（批量接口）
    if (Array.isArray(_params)) {
        paramStr = JSON.stringify(_params);
    } else if ((_params && _params._meth === 'body' || _method.toLowerCase() === 'post')) {
        paramStr = ((_params && _params._meth === 'body' || _method.toLowerCase() === 'body') ? JSON.stringify(_params) : Tools._getSearchFromObjectNoEncode(CommonUtil.objSort(_params)).substring(1));
    } else if (_method === 'GET') {
        if (Object.prototype.toString.call(_params) === '[object Object]') {
            if (_params && Object.keys(_params).length > 0) {
                let obj = CommonUtil.objSort(_params);
                Object.keys(obj).forEach((key) => {
                    paramStr += (key + obj[key]);
                })
            }
        }
    }

    let _options = {
        method: _method,
        // mode: "cors",
        headers: {
            'Content-Type': (Array.isArray(_params) || (_params && _params._meth === 'body')) ? 'application/json;charset=utf-8' : 'application/x-www-form-urlencoded',
            'yunshltoken': token,
            'timestamp': CommonUtil.getNonce(),
            'nonce': CommonUtil.getRandomParam(),
            'tokentype': AppUtil.isApp ? 'APP' : (isMobile ? 'WEBAPP' : 'PC'),
            'appsource': AppUtil.isIos ? 'IOS' : (AppUtil.isAndroid ? 'ANDROID' : (isMobile ? 'WEBAPP' : 'PC')),
        },
        body: (_method.toLowerCase() === 'get') ? null : (Array.isArray(_params) ? JSON.stringify(_params) : (_params && _params._meth === 'body' ? JSON.stringify(_params) : Tools._getSearchFromObject(_params).substring(1))),
    };
    // console.log('timestamp',_options.headers.timestamp)
    // console.log('nonce',_options.headers.nonce)
    // console.log('content',paramStr)
    let checkKey = reqKey + _options.headers.yunshltoken + _options.headers.timestamp + _options.headers.nonce + paramStr;
    _options.headers.signnatrue = md5(checkKey);
    if (_method.toLowerCase() == 'get') {
        _url += Tools._getSearchFromObject(_params);
    }
    fetch(_url, _options)
        .then(Tools.checkStates)
        .then(Tools.parseJSON)
        .then((data) => {
            if (typeof _onSuccess === 'function') {
                _onSuccess(data);
            }
        })
        .catch((err) => {
            console.log('_url====>', _url);
            console.log('err====>', err);
            if (err.state == 401) {
                console.log('err.state==========>', err.state)
                const lang = StorageUtil.getItem(SystemConst.lang) || 'zh';
                let titleTips = messages[lang]['DengLuGuoQi'] || '登录过期';
                let contentTips = messages[lang]['DLGQ_QCXDL'] || '登录信息已经过期，请重新登录';
                let statusCode = undefined;
                if (err["status-code"] && !window.statusCode) {
                    statusCode = err["status-code"];
                    if (statusCode === '401.3') {
                        //下线通知,您的账号已在其他设备登录，请重新登录。如非本人操作，请及时修改密码
                        titleTips = messages[lang]['XiaXianTongZhi'] || '下线通知';
                        contentTips = messages[lang]['NDZHYZQTSB'] || '您的账号已在其他设备登录，请重新登录。如非本人操作，请及时修改密码';
                    } else if (statusCode === '401.4') {
                        //登录过期，登录信息已经过期，请重新登录
                        titleTips = messages[lang]['DengLuGuoQi'] || '登录过期';
                        contentTips = messages[lang]['DLGQ_QCXDL'] || '登录信息已经过期，请重新登录';
                    }
                }
                if (!window.statusCode) {
                    window.statusCode = statusCode;
                    let btnSetting = {
                        confirmLabel: messages[lang]['QueDing'] || '确定'
                    };
                    if (StorageUtil.getItem('isMgr') === 0) {
                        btnSetting = {cancelLabel: messages[lang]['QuXiao'] || '取消'};
                    }
                    Util.title(titleTips, contentTips, btnSetting).then(() => {
                        BusinessUtil.toLogout();
                        window.statusCode = undefined;
                        return;
                    }, () => {
                        if (!StorageUtil.getItem('allowVisitor')) {
                            BusinessUtil.toLogout();
                        } else {
                            BusinessUtil.clearAccount();
                        }
                    })
                }

            }
            if (err.response) {
                err.response.text().then((text) => {
                    if (!text) return;
                    let data = {};
                    try {
                        data = JSON.parse(text);
                    } catch (parseErr) {
                        return;
                    }
                    if (data.message)
                        console.error(data.message)
                }).catch(() => {})
            }
            if (typeof _onError === "function") {
                _onError(err);
            }
        })
}

let Tools = {
    // 检查请求响应
    checkStates: function (response) {
        // document.getElementById('loading').setAttribute('class', 'loadEffect');
        if (response.ok) {
            return response
        } else {
            let error = new Error(response.statusText);
            error["status-code"] = response.headers.get("status-code");
            error.state = response.status;
            error.response = response;
            throw error;
        }
    },
    // 解析成json串
    parseJSON: function (response) {
        return response.json();
    },
    // 拼接get请求参数到url
    _getSearchFromObject: function (param, key) {
        if (param == null) return '';
        if (typeof param !== 'object') {
            return ''
        }
        let _search = '?';
        for (let key in param) {
            _search += `${key}=${encodeURIComponent(param[key])}&`
        }
        return _search.slice(0, -1);
    },
    // 拼接get请求参数到url
    _getSearchFromObjectNoEncode: function (param, key) {
        if (param == null) return '';
        if (typeof param !== 'object') {
            return ''
        }
        let _search = '?';
        for (let key in param) {
            _search += `${key}=${(param[key])}&`
        }
        return _search.slice(0, -1);
    },
};




// WEBPACK FOOTER //
// ./src/config/route-fetch.js